import React from 'react'
import { Stack, Text } from '@mantine/core'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import CompanyCard from './CompanyCard'
import { CompanyItem } from './types'
import { useTheme } from '../../../components/ThemeProvider'

interface CompanyListProps {
  companies: CompanyItem[]
}

const CompanyList: React.FC<CompanyListProps> = ({ companies }) => {
  const theme = useTheme()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联企业详情
      </Text>
      <Stack gap="sm" className="mt-3">
        <ExpandableListWrapper isEmpty={companies.length === 0}>
          {companies.map((company, index) => (
            <CompanyCard key={index} company={company} index={index + 1} />
          ))}
        </ExpandableListWrapper>
      </Stack>
    </div>
  )
}

export default CompanyList
